import { render, staticRenderFns } from "./input-tags.component.vue?vue&type=template&id=0b708260"
import script from "./input-tags.component.ts?vue&type=script&lang=ts&external"
export * from "./input-tags.component.ts?vue&type=script&lang=ts&external"
import style0 from "./input-tags.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports